import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Addon = ApplicationRecord.extend({
  static: {
    jsonapiType: 'addons',
  },
  attrs: {
    name: attr(),
    priceWith: attr(),
    priceWithout: attr(),
    isElementary: attr(),
    isHoliday: attr(),
    isSenior: attr(),
    popup: attr(),
    cssName: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    imageCount: attr(),
    component: belongsTo(),
    description: attr(),
    tagline: attr(),
    quantity: attr(),
    imageUrl: attr(),
    backImageUrl: attr(),
    blankImageUrl: attr(),
    horizImageUrl: attr(),
    backgroundSelection: attr(),
  },
});

export default Addon;
